<template>
  <custom-dialog width="500px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <!-- 用户信息 -->
      <el-form :model="form" :rules="rules" ref="form">
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('base_dictionary_item_dialog.zi_dian_dai_ma')" prop="dicCode">
              <el-input v-model="form.dicCode"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('base_dictionary_item_dialog.zi_dian_zhi')" prop="dicValue">
              <el-input v-model="form.dicValue"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item :label="$t('base_dictionary_item_dialog.zi_dian_ming_cheng')" prop="dicName">
              <el-input v-model="form.dicName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('base_dictionary_item_dialog.duo_yu_yanKey')" prop="langDicName">
              <el-input v-model="form.langDicName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('base_dictionary_item_dialog.miao_shu_wen_zi')" prop="showOrder">
              <el-input-number v-model="form.showOrder" :min="1" :max="1000" :label="$t('base_dictionary_item_dialog.miao_shu_wen_zi')"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="group.dicType == 2">
            <el-form-item :label="$t('base_dictionary_item_dialog.shang_ji_zi_dian')" prop="parentId">
              <custom-select
                v-model="form.parentId"
                :props="{ label: 'dicName', value: 'dicId', checkStrictly: true }"
                type="tree"
                url="DictionaryTree"
                :show-all-levels="false"
                :params="{ groupCode: group.groupCode, dicId: dicId }"
              ></custom-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('base_dictionary_item_dialog.zi_dian_zhi2')">
              <el-input v-model="form.dicValue2"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('base_dictionary_item_dialog.zi_dian_zhi3')">
              <el-input v-model="form.dicValue3"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" v-if="model.type === 'add'" @click="keepAddGroupItem">{{ $t('base_dictionary_item_dialog.ji_xu_tian_jia') }}</el-button>
      <el-button type="primary" @click="saveGroupItem">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      group: {},
      groupItemList: [],
      dicId: '',
      form: {
        groupId: '',
        dicCode: '',
        dicName: '',
        dicValue: '',
        dicValue2: '',
        dicValue3: '',
        langDicName: '',
        parentId: null,
        showOrder: 0,
      },
    };
  },
  computed: {
    rules() {
      return {
        groupId: {
          required: true,
          message: this.$t('base_dictionary_item_dialog.fen_zuidbi_tian'),
        },
        dicCode: [
          {
            required: true,
            message: this.$t('base_dictionary_item_dialog.zddmbt'),
          },
          { max: 50, message: this.$t('Common.com_rules_length_max', [50]), },
        ],
        dicName: [
          {
            required: true,
            message: this.$t('base_dictionary_item_dialog.zdmcbt'),
          },
          { max: 100, message: this.$t('Common.com_rules_length_max', [100]), },
        ],
        dicValue: [
          {
            required: true,
            message: this.$t('base_dictionary_item_dialog.zi_dian_zhi_bi_tian'),
          },
          { max: 200, message: this.$t('Common.com_rules_length_max', [200]), },
        ],
        langDicName: [
          {
            required: true,
            message: this.$t('base_dictionary_item_dialog.duo_yu_yan_bi_tian'),
          },
          { max: 100, message: this.$t('Common.com_rules_length_max', [100]), },
        ],
      };
    },
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.group = this.model.data.group; // 所属分组
      this.form.groupId = this.model.data.group.groupId;
      if (this.model.type === 'add') {
        this.groupItemList = this.model.data.groupItemList;
      }
      if (this.model.type === 'edit') {
        this.dicId = this.model.data.item.dicId;
        this.form.dicCode = this.model.data.item.dicCode;
        this.form.dicName = this.model.data.item.dicName;
        this.form.dicValue = this.model.data.item.dicValue;
        this.form.dicValue2 = this.model.data.item.dicValue2;
        this.form.dicValue3 = this.model.data.item.dicValue3;
        this.form.langDicName = this.model.data.item.langDicName;
        this.form.parentId = this.model.data.item.parentId === '0' ? null : this.model.data.item.parentId;
        this.form.showOrder = this.model.data.item.showOrder;
        this.getGroupItemTree();
      }
    },
    // 下拉树配置
    normalizer(node) {
      return {
        id: node.dicId,
        label: node.dicName,
      };
    },
    // 获取字典项树
    getGroupItemTree: function () {
      this.$getJSON(apis.DictionaryTree, {
        groupCode: this.group.groupCode,
        dicId: this.dicId,
      }).then((res) => {
        this.groupItemList = res.data;
      });
    },
    // 确认保存字典项
    saveGroupItem: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        if (this.model.type === 'add') {
          this.saveAddGroupItem();
        }
        if (this.model.type === 'edit') {
          this.saveEditGroupItem();
        }
      });
    },
    getParentId() {
      if (Array.isArray(this.form.parentId)) {
        const len = Math.max(0, this.form.parentId.length - 1);
        return this.form.parentId[len] || '0';
      }
      return this.form.parentId || '0';
    },
    // 确认保存字典项
    keepAddGroupItem: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        const data = this.form;
        data.parentId = this.getParentId();
        this.$postJSON(apis.DictionaryAdd, this.form).then(() => {
          this.$message({
            message: this.$t('Common.com_add_success'),
            type: 'success',
          });
          // 清空input值
          this.form.dicName = '';
          this.form.dicCode = '';
          this.form.dicValue = '';
          this.form.dicValue2 = '';
          this.form.dicValue3 = '';
          this.form.parentId = null;
          this.form.showOrder = this.form.showOrder + 1;
          this.form.langDicName = this.form.langDicName;
          this.$nextTick(() => {
            this.$refs.form.clearValidate();
          });
          this.$emit('success');
        });
      });
    },
    // 保存新增字典项
    saveAddGroupItem: function () {
      const data = this.form;
      data.parentId = this.getParentId();
      this.$postJSON(apis.DictionaryAdd, this.form).then(() => {
        this.$message({
          message: this.$t('Common.com_add_success'),
          type: 'success',
        });
        this.$emit('success');
        this.visible = false;
      });
    },
    // 保存编辑字典项
    saveEditGroupItem: function () {
      const data = this.form;
      data.parentId = this.getParentId();
      this.form.dicId = this.dicId;
      this.$postJSON(apis.DictionaryUpdate, this.form).then(() => {
        this.$message({
          message: this.$t('Common.com_edit_success'),
          type: 'success',
        });
        this.$emit('success');
        this.visible = false;
      });
    },
  },
};
</script>

<style lang="scss"></style>
